import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { canCancel } from '../../../../domain'
import { useProduct } from '../../ProductProvider'
import { usePolicy } from '../PolicyProvider'
import { CancellationConfirmPage } from './CancellationConfirmPage'
import { CancellationFactory } from './CancellationFactory'
import { CancellationPath } from './CancellationPath'

export const CancellationRouter: FunctionComponent = () => {
  const {
    product: { cancellation },
  } = useProduct()
  const { policy } = usePolicy()

  return canCancel(policy, cancellation) ? (
    <Routes>
      <Route key='cancel' index element={<CancellationFactory config={cancellation} />} />
      <Route
        key='confirm'
        path={CancellationPath.CONFIRM}
        element={<CancellationConfirmPage />}
      />
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  ) : (
    <Navigate to='..' />
  )
}
